import { render, staticRenderFns } from "./PayImgInfo.vue?vue&type=template&id=0b531f42&scoped=true&"
import script from "./PayImgInfo.vue?vue&type=script&lang=js&"
export * from "./PayImgInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayImgInfo.vue?vue&type=style&index=0&id=0b531f42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b531f42",
  null
  
)

export default component.exports